// 共享常量 - 经济系统参数

export const INITIAL_CASH = 5_000_000;
export const DAILY_SIGNIN_BONUS = 10_000;
export const TASK1_BUY_BONUS = 10_000;
export const TASK1_DAILY_CAP = 1;
export const TASK2_HEIST_RATIO = 0.2;
export const TASK2_HEIST_INTERVAL = 2;
export const TASK3_PROFIT_THRESHOLD = 0.03;
export const TASK3_PROFIT_BONUS = 20_000;

/** 黑哥们事件严重度 → 一次抽几只股（被抽中 100% 清空） */
export const HEIST_COUNT_BY_SEVERITY: Record<1 | 2 | 3 | 4 | 5, [number, number]> = {
  1: [1, 1],
  2: [1, 2],
  3: [2, 3],
  4: [3, 5],
  5: [5, 8],
};

/** 财产保险（小额）：30 分钟内 100% 返还（限 1 次） */
export const INSURANCE_PRICE = 10_000;
export const INSURANCE_DURATION_MS = 30 * 60 * 1000;
export const INSURANCE_RETURN_RATIO = 1.0;

/** 金融保险 - 3 档系统 */
export const FINANCE_INSURANCE_DELAY_MS = 2 * 60 * 60 * 1000; // 购买后 2 小时生效

export const FINANCE_INSURANCE_TIERS = {
  tier1: {
    id: 'tier1' as const,
    label: '基础档',
    priceRatio: 0.05, // 总资产 5%
    /** 赔付上限 = 总保费 × 这个倍数 */
    payoutMultiplier: 0.5,
    /** 有效期 */
    durationMs: 2 * 24 * 60 * 60 * 1000, // 2 天
    /** 每天最多赔付次数 */
    maxPayoutsPerDay: 1,
    color: '#52c41a',
  },
  tier2: {
    id: 'tier2' as const,
    label: '标准档',
    priceRatio: 0.1, // 总资产 10%
    payoutMultiplier: 1.0,
    durationMs: 2 * 24 * 60 * 60 * 1000, // 2 天
    maxPayoutsPerDay: 2,
    color: '#1677ff',
  },
  tier3: {
    id: 'tier3' as const,
    label: '尊享档',
    priceRatio: 0.2, // 总资产 20%
    payoutMultiplier: Infinity, // 无上限
    durationMs: 1 * 24 * 60 * 60 * 1000, // 1 天
    maxPayoutsPerDay: Infinity, // 不限次
    color: '#ffd700',
  },
} as const;

export type FinanceInsuranceTier = keyof typeof FINANCE_INSURANCE_TIERS;

/** 数字保镖（替代原雇佣保安）：按账户总市值 2% 计费，24h 内每次事件 20% 概率完全拦截 */
export const GUARD_PRICE_RATIO = 0.02;
export const GUARD_BLOCK_RATE = 0.2;
export const GUARD_DURATION_MS = 24 * 60 * 60 * 1000;

/** 合约参数 */
export const CONTRACT_LEVERAGES: (1 | 5 | 10 | 20)[] = [1, 5, 10, 20];
/** 维持保证金率 = 1 - 10%（亏损超过 90% 强平） */
export const CONTRACT_MAINTENANCE_MARGIN_RATIO = 0.1;
/** 资金费率（每 8 小时一次） */
export const CONTRACT_FUNDING_RATE = 0.0001; // 0.01% / 8h
export const CONTRACT_FUNDING_INTERVAL_MS = 8 * 60 * 60 * 1000;

/** A 股交易时段：9:30-11:30, 13:00-15:00（北京时间） */
export const A_SHARE_SESSIONS: [number, number][] = [
  [9 * 60 + 30, 11 * 60 + 30], // 9:30 - 11:30
  [13 * 60, 15 * 60], // 13:00 - 15:00
];

/** A 股每周交易日：周一到周五（0=周日, 6=周六） */
export const A_SHARE_TRADING_DAYS = [1, 2, 3, 4, 5];

/** 行情刷新间隔（毫秒） */
export const QUOTE_REFRESH_MS = 5000;
